import React from 'react';
import { BaseDesktopSearchCard } from '../Base/Desktop';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { SearchCard } from '../types';
import {
  Price,
  GrayUIText,
  Title,
  BottomContent,
  GrayPrice,
  DisclaimerContentText,
} from '../Base/styles';
import { TruckIcon, MapMarkerIcon, BoxConditionIcon } from '../../../../assets';

const StyledContentText = styled(DisclaimerContentText)`
  white-space: nowrap;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
  overflow: hidden;
`;

const PriceCondition = styled.span`
  ${theme.typography.headings[5]['sm-lg']};
  color: ${theme.colors.neutrals.solidGrays[3]};
`;

export const AutoBuyNowDesktopSearchCard: React.FC<
  SearchCard<'AutoBuyNow'>
> = ({
  title,
  price,
  grayPrice,
  condition,
  location,
  isDelivery,
  data,
  type,
  ...props
}) => {
  return (
    <BaseDesktopSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <div>
          {grayPrice && <GrayPrice>{grayPrice}</GrayPrice>}
          <Price>
            {price}
            <PriceCondition>*</PriceCondition>
          </Price>
          <StyledContentText>{data.disclaimerText}</StyledContentText>
        </div>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.primary.graysGray}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              <>
                <TruckIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                Delivery
              </>
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseDesktopSearchCard>
  );
};
